/**
* AI写作-发布任务
**/ 

<template>
    
  <div class="ai-publish">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item >发布任务</el-breadcrumb-item>
      <!-- <el-breadcrumb-item v-if="detailShow">详情</el-breadcrumb-item> -->
    </el-breadcrumb>
    <el-card class="box-card">
      <!-- 标题列表 s -->
      <div class="box-table">

        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline"  :size="size" ref="ruleForm0" >
          <el-form-item  prop="keyword">
            <el-input placeholder="任务名称" v-model="formInline.keyword"> </el-input>
          </el-form-item>
          <el-form-item  prop="configId">
            <el-select  style="width:100%" v-model="formInline.configId"   placeholder="站点" >
                <el-option v-for="item in configList" :key="item.id" :label="item.domain" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  prop="state">
            <el-select   style="width:100%" v-model="formInline.state" placeholder="状态"  >
                <el-option :label="'进行中'" :value="0"> </el-option>
                <el-option :label="'已完成'" :value="1"> </el-option>
                <el-option :label="'任务终止'" :value="2"> </el-option>
                <el-option :label="'任务暂停'" :value="3"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button  icon="el-icon-search" @click="search">搜索</el-button>
            <el-button @click="resetForm('ruleForm0')" plain>重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <el-row :gutter="20" style="margin-top:10px">
            <el-col :span="2.5">
                <div class="grid-content bg-purple">
                    <el-button :size="size" type="danger" plain icon="el-icon-s-promotion" @click="publishHandler('auto')">添加自动发布任务</el-button>
                </div>
            </el-col>
            <el-col :span="10">
                <div class="grid-content bg-purple" v-show="buttonShow">
                    <el-button :size="size" type="warning" plain @click="modifyHander(3)">暂停</el-button>
                    <el-button :size="size" type="warning" plain @click="modifyHander(2)">终止</el-button>
                    <el-button :size="size" type="warning" plain @click="modifyHander(0)">恢复</el-button>
                    <el-button :size="size" type="warning" plain @click="modifyHander(4)">重启</el-button>
                </div>
            </el-col>
        </el-row>
        <!--列表-->
        <el-table size="small" ref="multipleTable" tooltip-effect="dark" :data="listData" 
        highlight-current-row v-loading="loading" element-loading-text="拼命加载中"
         style="width: 100%;margin-top:20px" @selection-change="handleSelectionChange">
           <el-table-column  type="selection" width="55"> </el-table-column>
          <el-table-column sortable  prop="id" label="编号" >
          </el-table-column>
          <el-table-column sortable prop="name" label="任务名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="keywordGroup" label="关键词组" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="keywords" label="关键词" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="state" label="状态">
            <template slot-scope="scope">
              <span>{{scope.row.state | state}}</span>
            </template>
          </el-table-column>
          <el-table-column sortable prop="totalCount" label="发布文章总数量" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="completeCount" label="已完成数量" show-overflow-tooltip>
          </el-table-column>
          <el-table-column sortable prop="createTime" label="创建时间" >
            <template slot-scope="scope">
              <div>{{scope.row.createTime|timestampToTime}}</div>
            </template>
          </el-table-column>
          <el-table-column sortable prop="mode" label="文章生成模式" >
            <template slot-scope="scope">
              <div>{{scope.row.mode==1?'手动':'自动'}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template  slot-scope="scope">
              <el-button type="text" size="mini" @click="editHandler(scope.row, 1)" v-show="scope.row.state==0||scope.row.state==3">编辑</el-button>
              <el-button type="text" size="mini" @click="to(`/ai/article?configId=${scope.row.configId}`)">内容</el-button>
              <el-button type="text" size="mini" @click="editHandler(scope.row, 2)">复制</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination style="float:right" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

      </div>
      <!-- 标题列表 e -->
    </el-card> 
    <!-- 发布任务/编辑任务/复制任务 -->
    <el-dialog
        top="15px"
        :title="flag==2?'复制发布任务':(flag==1?'编辑发布任务':'添加发布任务')"
        :visible.sync="configDialogVisible"
        width="50%"
        :close-on-click-modal="false"
        @close="dialogClose">
        <el-steps :active="tabActive" simple style="font-size:14px !important">
            <el-step title="任务信息" ></el-step>
            <el-step title="选择配置" ></el-step>
            <el-step title="发布规则" ></el-step>
        </el-steps>
        <div >
            <el-form style="padding:20px 20px" :model="task_form1" :rules="rules1"  ref="ruleForm1" :size="size" v-show="tabActive==1">
                <el-form-item label="任务名称" prop="name">
                    <el-input v-model="task_form1.name" clearable placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="关键词组" prop="tranname">
                    <el-select
                        placeholder="请输入或选择"
                        v-model="task_form1.group"
                        style="width: 100%;"
                        ref="valSelect"
                        filterable
                        @blur="valSelectBlur"
                        @focus="valSelectFocus"
                        @change="valSelectChange"
                        >
                        <el-option v-for="item in options" :key="item" :label="item" :value="item">
                        </el-option>
                    </el-select>
                    <el-input v-model="task_form1.tranname" clearable style="width:90%;position: absolute;left: 0px;border: 0px solid blue" @blur="valInputBlur" ref="valInput"
                    @focus="valInputFocus"></el-input>
                </el-form-item>
                <el-form-item label="关键词" prop="keywords">
                    <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 20}" placeholder="请输入（一行一个关键词）"
                        v-model="task_form1.keywords">
                    </el-input>
                </el-form-item>
                <el-form-item style="text-align:right" >
                    <el-button @click="configDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitFun1('ruleForm1')">下一步</el-button>
                </el-form-item>
            </el-form>
            <el-form style="padding:20px 20px" :model="task_form2" :rules="rules2"  ref="ruleForm2" :size="size" v-show="tabActive==2">
                <el-form-item label="发布配置" prop="index">
                    <el-select
                        v-model="task_form2.index"
                        style="width: 60%;"
                        @change="configSelectChange"
                        >
                        <el-option v-for="(item, index)  in configList" :key="index" :label="item.name" :value="index">
                        </el-option>
                    </el-select>
                    <el-button type="primary" plain icon="el-icon-plus" circle :size="size" style="margin-left:10px" @click="to('/ai/config?operation=add')"></el-button>
                </el-form-item>
                <el-form-item label="站点" v-if="configTemp">
                    <el-input type="text"  v-model="configTemp.domain" disabled> </el-input>
                </el-form-item>
                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="发布时间"  v-if="configTemp">
                            <el-input type="text"  v-model="configTemp.publishTime" disabled> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="每日发布量"  v-if="configTemp">
                            <el-input type="text"  v-model="configTemp.count" disabled> </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item style="text-align:right" >
                    <el-button @click="tabActive=1">上一步</el-button>
                    <el-button type="primary" @click="submitFun2('ruleForm2')">下一步</el-button>
                </el-form-item>
            </el-form>
            <el-form style="padding:20px 20px" :model="task_form3" :rules="rules3"  ref="ruleForm3" :size="size" v-show="tabActive==3">
                <el-form-item label="总文章数量" prop="totalCount">
                    <el-input type="number"  v-model="task_form3.totalCount" step=10 min=0> </el-input>
                </el-form-item>
                <el-form-item label="标题格式" prop="ruleTitle">
                    <el-select v-model="task_form3.ruleTitle"  placeholder="请选择" style="width:100%">
                      <el-option label="肯定句" value="肯定句"></el-option>
                      <el-option label="疑问句" value="疑问句"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="文章生成模式" prop="mode">
                    <el-select v-model="task_form3.mode"  placeholder="请选择" style="width:100%" >
                      <el-tooltip class="item" effect="dark" content="每日自动生成需发布的文章数量，到发布时间按指定篇幅自动发布" placement="top-start">
                        <el-option label="自动" :value="0"></el-option>
                      </el-tooltip>
                      <el-tooltip class="item" effect="dark" content="到文章库手动批量生成文章，到发布时间按指定篇幅自动发布" placement="top-start">
                        <el-option label="手动" :value="1"></el-option>
                      </el-tooltip>
                      
                    </el-select>
                </el-form-item>
                <el-form-item style="text-align:right" >
                    <el-button @click="tabActive=2">上一步</el-button>
                    <el-button type="primary" @click="submitFun3('ruleForm3')">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入组件
import Pagination from '@/components/Pagination'
import moment from 'moment'

import { getKeywordGroup,getOneKeywordByGroup, addKeyword, createPublish, 
  modifyPublish, getConfig, getPublish,modifyPublishStatus} from '@/api/basisMG' 
//实体类

// 导出模块
export default {
  // 模块名字
  name: "aiArticle",
  // 模块数据
  data() {
    //数据  
    return {
        buttonShow: false, //操作按钮显示
        addDialogVisible: false, //添加对话框显示
        detailDialogVisible: false, //详情对话框显示
        configDialogVisible: false, //详情对话框显示
        tabActive: 1, //是否可以通过点击 modal 关闭 Dialog
        loading: false,
        size: 'small',
        formInline: {
            page: 1,
            pageSize: 10,
            tag: '',
            keyword: '',
            configId: null,
            state: null
        },
        // 分页参数
        pageparm: {
            currentPage: 1,
            pageSize: 10,
            total: 0
        },
        listData:[],
        flag: 0, //0-添加 1-编辑 2-复制
        configList:[],
        task_form1: {
            tranname: '',
            name: '',
            group: '',
            keywords: '',
            id: null,
        },
        rules1:{
            name: [ { required: true, message: '请输入任务名称', trigger: 'blur' } ],
            tranname: [ { required: true, message: '请输入关键词组', trigger: 'blur' } ],
            keywords: [ { required: true, message: '请输入关键词', trigger: 'blur' } ],
        },
        task_form2: {
            index: null
        },
        rules2:{
            index: [ { required: true, message: '请选择发布配置', trigger: 'blur' } ],
        },
        task_form3: {
            ruleTitle: '肯定句',
            totalCount: 10,
            id: null,
            mode: 0
        },
        rules3:{
            totalCount: [ { required: true, message: '请输入文章数量', trigger: 'blur' } ],
        },
        configTemp: null,
        options: [],  
        optionsAll: [],
        inputOneFocus: true,
        valSelectFocusVal: false,
        valInputFocusVal: false,
    };
  },
  // 注册组件
  components: {
    Pagination
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {
        "task_form1.tranname": function(val) {
            var data = [];
            for (var i = 0; i < this.optionsAll.length; i++) {
                if (this.optionsAll[i].indexOf(val) >= 0 || val == 0) {
                    data.push(this.optionsAll[i]);
                }
                if(this.optionsAll[i]==val){
                    getOneKeywordByGroup({group: val})
                        .then(res => {
                        if (res.code === 0) {
                            this.task_form1.keywords = res.data.keywords
                            this.task_form1.id = res.data.id
                        } else {
                            console.log(res.message)
                        }
                    })
                }
            }
            this.options = data;
            this.$refs.valSelect.focus();
            if(this.options.length==0){
              this.task_form1.id=null
              this.task_form1.keywords=''
            }
        }
    },
		
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    to(path){
        window.open(path,'_blank')
    },
    addFun() {
      if(this.publishType=='auto'){

      }else if(this.publishType=='manual'){

      }
    },
    submitFun1(formName) {
        //提交词组
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.task_form1.id){
              addKeyword({group: this.task_form1.tranname, keywords:this.task_form1.keywords}).then(res=>{
                if(res.code==0){
                  this.getGroupData()
                }
             })
            }
            //进行下一步
            this.tabActive = 2
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    submitFun2(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //进行下一步
            this.tabActive = 3
          } else {
            return false;
          }
        });
    },
    submitFun3(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            //提交
            const params = {
              name: this.task_form1.name,
              keywordGroup: this.task_form1.tranname,
              keywords: this.task_form1.keywords,
              totalCount: this.task_form3.totalCount,
              configId: this.configList[this.task_form2.index].id,
              ruleTitle: this.task_form3.ruleTitle,
              mode: this.task_form3.mode
            }
            if(!this.task_form3.id){
              createPublish(params).then(res=>{
                if(res.code===0){
                  this.$message.success('提交成功')
                  this.dialogClose()
                  this.search()
                }else{
                  this.$message.error(res.message)
                }
              })
            }else{
              modifyPublish(this.task_form3.id,params).then(res=>{
                if(res.code===0){
                  this.$message.success('编辑成功')
                  this.dialogClose()
                  this.search()
                }else{
                  this.$message.error(res.message)
                }
              })
            }
            
          } else {
            return false;
          }
        });
    },
     // 获取发布任务列表
     getdata(parameter) {
        const params={
          keyword: parameter.keyword,
            configId: parameter.configId,
            state: parameter.state,
            page: parameter.page,
            pageSize: parameter.pageSize,
        }
        this.loading = true
        getPublish(params)
            .then(res => {
            this.loading = false
            if (res.code == 0) {
                this.listData = res.data
                // 分页赋值
                this.pageparm.currentPage = this.formInline.page
                this.pageparm.pageSize = this.formInline.pageSize
                this.pageparm.total = res.totalCount
            } else {
                
              this.$message({ type: 'error', message: res.message })
            }
        })
    },
    search(){
        this.getdata(this.formInline)
    },
    getGroupData(){
      getKeywordGroup()
            .then(res => {
            if (res.code === 0) {
                this.optionsAll = res.data
            } else {
                console.log(res.message)
            }
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    openDetail(row){
        this.temp = row
        this.detailDialogVisible=true
    },
    publishHandler(){
        this.task_form1.name=''
        this.task_form1.tranname = ''
        this.task_form1.keywords = ''
        this.task_form1.id = null
       
        this.configTemp = null
        this.task_form2.index = null
        this.task_form3.totalCount =10
       this.flag = 0
       this.configDialogVisible = true
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    configSelectChange(val){
        this.configTemp = this.configList[val]
    },
    editHandler(row, num){
        this.task_form1.name=row.name
        this.task_form1.tranname = row.keywordGroup
        this.task_form1.keywords = row.keywords
       
        this.configList.forEach((item, index)=>{
            if(item.id == row.configId){
                this.configTemp = item
                this.task_form2.index = index
                return
            }
        })
        this.task_form3.totalCount = row.totalCount
        this.task_form3.mode = row.mode
        //编辑赋值ID,复制不赋值ID
        if(num==1){
          this.task_form3.id = row.id
        }else{
          this.task_form3.id = null
        }
        this.flag = num
        this.configDialogVisible = true
    },
    handleSelectionChange(){
        console.log(this.$refs.multipleTable.selection)
        if(this.$refs.multipleTable.selection.length>0){
            this.buttonShow = true
        }else{
            this.buttonShow = false
        }
    },
    modifyHander(index){
      // 3-暂停、0-恢复、2-终⽌、4-重启
      console.log(this.$refs.multipleTable.selection)
      let error = []
      let array = []
      if(this.$refs.multipleTable.selection.length>0){
        this.$refs.multipleTable.selection.forEach(e => {
          array.push(e.id)
          if(index===3 && e.state!=0){
            //只有进行中的数据才能暂停
            error.push(false)
          }else if(index===2 && e.state!=0 && e.state!=3 ){
            //只有进⾏中/暂停的数据才能终止
            error.push(false)
          }else if(index===4 && e.state!=2){
            //只有已终止的数据才能重启
            error.push(false)
          }else if(index===0 && e.state!=3 ){
            //只有暂停的数据才能恢复
            error.push(false)
          }
        });
        if(error.length>0){
          if(index===3){
            this.$message.warning('存在不可暂停任务，请重新选择')
          }else if(index===2){
            this.$message.warning('存在不可终止任务，请重新选择')
          }else if(index===4){
            this.$message.warning('存在不可重启任务，请重新选择')
          }else if(index===0){
            this.$message.warning('存在不可恢复任务，请重新选择')
          }
          return false
        }
      }else{
        this.$message.warning('请选择操至少一条记录进行操作')
        return false
      }
      // 0-进行中，1-已完成，2-终止，3-暂停 ,4-作废
      let params = {state: index, ids:array}
      modifyPublishStatus(params).then(res=>{
        if (res.code == 0) {
          this.$message({ type: 'success', message: "操作成功" })
          this.search()
        } else {
          this.$message({ type: 'error', message: res.message })
        }
      })
    },
    valSelectFocus() {
        this.valSelectFocusVal = true;
        this.$refs.valInput.focus();
    },
    valSelectBlur() {
        this.valSelectFocusVal = false;
    },
    valSelectChange(val) {
        this.valSelectFocusVal = false;
        this.task_form1.tranname = val;
        getOneKeywordByGroup({group: val})
            .then(res => {
            if (res.code === 0) {
                this.task_form1.keywords = res.data.keywords
                this.task_form1.id = res.data.id
            } else {
                console.log(res.message)
            }
        })
    },
    valInputBlur() {
        let that = this;
        that.valInputFocusVal = false;
        if (that.optionsAll.indexOf(that.task_form1.tranname) >= 0) {
            setTimeout(() => {
                if (that.valSelectFocusVal == false && that.valInputFocusVal == false) {
                    console.log("输入值在下拉项中存在");
                    that.inputOneFocus = true;
                }
            }, 100)
        }else{
            setTimeout(() => {
                if (that.valSelectFocusVal == false && that.valInputFocusVal == false) {
                    console.log("zzz");
                    that.inputOneFocus = true;
                }
            }, 500)
        }
    },
    valInputFocus() {
        this.valInputFocusVal = true;
        this.task_form1.group = this.task_form1.tranname;
        if(this.inputOneFocus){
            this.inputOneFocus = false;
            var data = [];
            for (var i = 0; i < this.optionsAll.length; i++) {
                if (this.optionsAll[i].indexOf(this.task_form1.tranname) >= 0 || this.task_form1.tranname == 0) {
                    data.push(this.optionsAll[i]);
                }
            }
            this.options = data;
            setTimeout(() => {
                this.$refs.valSelect.focus();
            }, 200)
        }
    },
    dialogClose(){
      this.configDialogVisible = false
      this.tabActive = 1
    },
    getConfigData(){
        getConfig({page:1, pageSize: 100}).then(res => {
            if (res.code == 0) {
                this.configList = res.data
            } 
        })
    }
  },
  filters: {
    timestampToTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:SS')
    },
    state(num) {
      switch (num) {
        case 0:
          return '进行中'
        case 1:
          return '已完成'
        case 2:
          return '终止'
        case 3:
          return '暂停'
        default:
          return ''
      }
    },
  },
  // 创建前状态(里面是操作)
  beforeCreate() {},
  // 创建完毕状态(里面是操作)
  created() {},
  // 挂载前状态(里面是操作)
  beforeMount() {},
  // 挂载结束状态(里面是操作)
  mounted() {
    this.getdata(this.formInline)
    this.getGroupData()
    this.getConfigData()
  },
  // 更新前状态(里面是操作)
  beforeUpdate() {},
  // 更新完成状态(里面是操作)
  updated() {},
  // 销毁前状态(里面是操作)
  beforeDestroy() {},
  // 销毁完成状态(里面是操作)
  destroyed() {}
};
</script>
// scoped 样式只在本组件使用
<style>
/**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */
 .ai-publish .ql-editor {
    font-size: 16px;
 }
 .ai-publish .el-form-item__label {
    font-size: 16px;
 }
 .ai-publish .el-step.is-simple .el-step__title {
    font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ai/writer/publish.vue